import { MutableRefObject } from 'react'
import { z } from 'zod'

import { ShippingAddressFormSchema } from 'Components/ShippingAddressForm/ShippingAddressForm.types'

import { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'

import { ReplacementType } from 'Portal/__generated__/globalTypes'

import {
  lostOrStolenModalSummarySchema,
  lostStolenReplacementFormSchema,
} from './LostOrStolenModal.schema'

export type LostStolenReplacementFormSchema = z.infer<
  typeof lostStolenReplacementFormSchema
>

export type LostOrStolenModalSummarySchema = z.infer<
  typeof lostOrStolenModalSummarySchema
>

export enum LostOrStolenModalTypesEnum {
  'EMPLOYEE' = 'EMPLOYEE',
  'ORGANISATION' = 'ORGANISATION',
  'ORGANISATION_WITH_DEPOT' = 'ORGANISATION_WITH_DEPOT',
}

export enum LostOrStolenModalStepsEnum {
  'LANDING' = '1',
  'REPLACEMENT_FORM' = '2',
  'SHIPPING_FORM' = '3',
  'SUMMARY' = '4',
  'CONFIRMATION' = '5',
}

export type LostOrStolenModalStepsMap = {
  [key: string]: {
    component: React.FunctionComponent<any>
    props: any
  }
}

export type LostOrStolenModalProps = {
  rental: getRental_rental
  type: `${LostOrStolenModalTypesEnum}`
  isShown: boolean
  onClose: () => void
  onSubmit: () => void
  setOnAfterClose: (onAfterClose: () => void) => void
}

export type LostOrStolenModalLandingProps = {
  type: `${LostOrStolenModalTypesEnum}`
  isNoReplacementEnabled: boolean
  isReplacementDeviceAvailableInDepot: boolean
  onSetCurrentStep: (step: `${LostOrStolenModalStepsEnum}`) => void
  onSetSelectionType: (type: ReplacementType) => void
  onSetShippingFormData: (data: ShippingAddressFormSchema | null) => void
}

export type LostOrStolenModalReplacementFormProps = {
  rental: getRental_rental
  onSetCurrentStep: (
    step: `${LostOrStolenModalStepsEnum}`,
    shippingData?: ShippingAddressFormSchema,
    replacementData?: LostStolenReplacementFormSchema,
  ) => void
}

export type LostOrStolenModalShippingFormProps = {
  rental: getRental_rental
  shippingFormData: ShippingAddressFormSchema | null
  onSetCurrentStep: (
    step: `${LostOrStolenModalStepsEnum}`,
    shippingData?: ShippingAddressFormSchema,
    replacementData?: LostStolenReplacementFormSchema,
  ) => void
}

export type LostOrStolenModalSummaryProps = {
  selectionType: ReplacementType
  rental: getRental_rental
  shippingFormData: ShippingAddressFormSchema | null
  replacementFormData: LostStolenReplacementFormSchema | null
  requestIdRef: MutableRefObject<string | null>
  messageRef: MutableRefObject<string | null>
  onSetCurrentStep: (step: `${LostOrStolenModalStepsEnum}`) => void
  onSubmit: () => void
}

export type LostOrStolenModalConfirmationProps = {
  selectionType: ReplacementType
  shippingFormData: ShippingAddressFormSchema | null
  requestIdRef: MutableRefObject<string | null>
  messageRef: MutableRefObject<string | null>
  onClose: () => void
}
